
import { escapeHTML, escapeRegExp, unique, LINK_REGEX, UPDATE_PROFILE_LINK_HTML } from '@/utils'

export default class LinkifyingFormatter {

  constructor(rawText, options = {}) {
    this.rawText = rawText
    this.maxLength = options.maxLength
    this.couponUrl = options.couponUrl
    this.hasCoupon = !!(this.couponUrl && this.couponUrl.length)
    this.hasImages = !!options.hasImages
    this.hasUpdateLink = !!options.hasUpdateLink
    // App.log('LinkifyingFormatter options: ', options)
  }

  formattedText() {
    let text = this.rawText

    // App.log('formattedText, raw_text: ', text)
    // App.log('  maxLength: ', this.maxLength)
    // App.log('  hasUpdateLink: ', this.hasUpdateLink)

    if (!text) return ''

    if (this.hasImages) {
      if (text.length > this.maxLength) {
        text = text.substring(0, this.maxLength);
        text = text.substring(0, text.lastIndexOf(" "));
      }
      text = this._linkifedText(text) + " - <a href='#' title='Images Link' target='_blank'>tsig.co/abc123</a>";
    } else {
      text = this._linkifedText(text);
    }

    if (this.hasUpdateLink) {
      text += UPDATE_PROFILE_LINK_HTML
    }

    return text
  }

  _linkifedText(text) {
    let matches
    // App.log("_linkifedText, text: >>" + text + "<<")
    text = this.normalizeHTML(text)
    matches = text.match(LINK_REGEX)

    if (matches) {
      // App.log("matches: ", matches)
      unique(matches).forEach(function(element, index, array) {
        let tag, url
        // App.log("element: ", element)
        // App.log("index: ", index)
        // App.log("array: ", array)
        if (element.indexOf("@") >= 0) {
          return
        }
        url = element
        if (url.indexOf("http") < 0) {
          url = "http://" + url
        }
        url = url.replace(/\.+$/g, '')
        tag = "<a href='" + url + "' target='_blank'>tsig.co/abc123</a>"
        return text = text.replace(new RegExp(escapeRegExp(element), "gmi"), tag)
      })
    }
    if (this.hasCoupon) {
      text += "<a href='http://" + this.couponUrl + "' class='coupon-link' title='Coupon Link' target='_blank'>" + this.couponUrl + "</a>"
    }
    // App.log('_linkifedText returning: ', text)
    return text
  }

  normalizeHTML(content) {
    // App.log("normalizeHTML before: ", content)
    content = escapeHTML(content)
    content = content.replace(/^/gm, "<div>")
    content = content.replace(/$/gm, "</div>")
    // App.log("normalizeHTML after: ", content)
    return content
  }

}
